import React from 'react';

function MonitorIcon({ fill, className }) {
  return (
    <svg
      className={className}
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18.4931 17.97H7.37311C3.39311 17.97 2.18311 16.76 2.18311 12.78V6.44C2.18311 2.46 3.39311 1.25 7.37311 1.25H18.4831C22.4631 1.25 23.6731 2.46 23.6731 6.44V12.77C23.6831 16.76 22.4731 17.97 18.4931 17.97ZM7.37311 2.75C4.23311 2.75 3.68311 3.3 3.68311 6.44V12.77C3.68311 15.91 4.23311 16.46 7.37311 16.46H18.4831C21.6231 16.46 22.1731 15.91 22.1731 12.77V6.44C22.1731 3.3 21.6231 2.75 18.4831 2.75H7.37311V2.75Z"
        fill={`${fill}`}
      />
      <path
        d="M12.9331 22.7502C12.5231 22.7502 12.1831 22.4102 12.1831 22.0002V17.2202C12.1831 16.8102 12.5231 16.4702 12.9331 16.4702C13.3431 16.4702 13.6831 16.8102 13.6831 17.2202V22.0002C13.6831 22.4102 13.3431 22.7502 12.9331 22.7502Z"
        fill={`${fill}`}
      />
      <path
        d="M22.9331 13.75H2.93311C2.52311 13.75 2.18311 13.41 2.18311 13C2.18311 12.59 2.52311 12.25 2.93311 12.25H22.9331C23.3431 12.25 23.6831 12.59 23.6831 13C23.6831 13.41 23.3431 13.75 22.9331 13.75Z"
        fill={`${fill}`}
      />
      <path
        d="M17.4331 22.75H8.43311C8.02311 22.75 7.68311 22.41 7.68311 22C7.68311 21.59 8.02311 21.25 8.43311 21.25H17.4331C17.8431 21.25 18.1831 21.59 18.1831 22C18.1831 22.41 17.8431 22.75 17.4331 22.75Z"
        fill={`${fill}`}
      />
    </svg>
  );
}

export default MonitorIcon;
